$(() => {
  $('.remove_fields.existing.destroyed').each(function () {
    const wrapper_class = $(this).data('wrapper-class') || 'nested-fields';
    $(this)
      .closest('.' + wrapper_class)
      .hide();
  });
});
